import React, { useMemo } from 'react'
import { ThemeProvider as SCThemeProvider } from 'styled-components'
import { ThemeProvider as MUIThemeProvider, createTheme } from '@mui/material/styles'
import defaultTheme from '../theme'
import { node } from 'prop-types'
import { useRecoilValue } from 'recoil'
import { companyInfoSelector } from '../state'

function Theme({ children }) {
  const companyInfo = useRecoilValue(companyInfoSelector)

  const currentTheme = useMemo(() => {
    const typography = {
      fontFamily: ['Lato-Regular'],
    }

    if (companyInfo?.company?.theme) {
      return createTheme({
        typography,
        palette: {
          primary: {
            main: companyInfo.company.theme.primary,
          },
          secondary: {
            main: companyInfo.company.theme.secondary,
          },
          onPrimary: {
            main: companyInfo.company.theme.onPrimary,
          },
          background: {
            main: companyInfo.company.theme.background,
          },
          surface: {
            main: companyInfo.company.theme.surface,
          },
        },
      })
    }

    return createTheme({
      typography,
      palette: {
        primary: {
          main: defaultTheme.primary,
        },
        secondary: {
          main: defaultTheme.secondary,
        },
        onPrimary: {
          main: defaultTheme.onPrimary,
        },
        background: {
          main: defaultTheme.background,
        },
        surface: {
          main: defaultTheme.surface,
        },
      },
    })
  }, [companyInfo])

  return (
    currentTheme && (
      <MUIThemeProvider theme={currentTheme}>
        <SCThemeProvider theme={currentTheme}>{children}</SCThemeProvider>
      </MUIThemeProvider>
    )
  )
}

Theme.propTypes = {
  children: node.isRequired,
}

export default Theme
